import React from "react";
import {
  ArrowUpRight,
  CheckCircle2,
  Globe,
  Layers,
  ShieldCheck,
  TrendingUp,
  Users,
  Zap,
} from "lucide-react";
import { Link } from "react-router-dom";

function AboutSection() {
  return (
    <>
      <section className="relative py-16 px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505]">
        {/* BACKGROUND EFFECTS */}
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

        <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:70px_70px]" />

        <div className="relative z-10 max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-stretch">
          {/* LEFT SIDE (60%) */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            {/* TAG */}
            <div className="inline-flex w-fit items-center gap-2 px-5 py-2 rounded-full border border-primary/20 bg-primary/10 text-primary text-sm font-semibold">
              About Our Company
            </div>

            {/* TITLE */}
            <h2 className="myheading  text-gray-900 dark:text-white mt-4">
              We Build{" "}
              <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">
                Digital Growth
              </span>{" "}
              Systems
            </h2>

            {/* SUBTITLE */}
            <h3 className="mysubheading text-gray-700 dark:text-gray-300">
              Modern Design. Scalable Technology. Real Business Results.
            </h3>

            {/* DESCRIPTION */}
            <p className="myparagraph text-gray-600 dark:text-gray-400 leading-tight">
              We create high-performance websites, scalable web applications,
              and conversion-focused digital experiences that help businesses
              grow faster in the modern digital world.
            </p>

            {/* LIST */}
            <div className="mt-8 space-y-4">
              <div className="flex gap-3">
                <CheckCircle2 className="w-5 h-5 text-primary mt-1" />
                <p className="text-gray-700 dark:text-gray-300">
                  Scalable UI/UX systems built for real-world applications
                </p>
              </div>

              <div className="flex gap-3">
                <CheckCircle2 className="w-5 h-5 text-primary mt-1" />
                <p className="text-gray-700 dark:text-gray-300">
                  High-performance web apps optimized for speed and SEO
                </p>
              </div>

              <div className="flex gap-3">
                <CheckCircle2 className="w-5 h-5 text-primary mt-1" />
                <p className="text-gray-700 dark:text-gray-300">
                  Conversion-focused design for better business growth
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-10">
              <Link
                to="https://webxsecure.in/contact"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary text-white font-semibold shadow-[0_0_40px_rgba(254,120,83,0.35)] hover:scale-105 transition"
              >
                Start Your Project
                <ArrowUpRight className="w-5 h-5" />
              </Link>
            </div>
          </div>

          {/* RIGHT SIDE (40%) - VISION + MISSION */}
          <div className="lg:col-span-5 flex flex-col justify-center gap-6">
            {/* VISION */}
            <div className="p-6 rounded-2xl border border-black/5 dark:border-white/10 bg-white/70 dark:bg-white/5 backdrop-blur-xl hover:scale-[1.02] transition">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                Our Vision
              </h3>
              <p className="mt-3 text-gray-600 dark:text-gray-400 leading-relaxed">
                To become a global digital agency delivering innovative,
                scalable, and high-performance solutions that empower businesses
                worldwide.
              </p>
            </div>

            {/* MISSION */}
            <div className="p-6 rounded-2xl border border-black/5 dark:border-white/10 bg-white/70 dark:bg-white/5 backdrop-blur-xl hover:scale-[1.02] transition">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                Our Mission
              </h3>
              <p className=" text-gray-600 dark:text-gray-400 leading-relaxed">
                To design and develop powerful digital products that combine
                creativity, performance, and technology to drive real business
                growth.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutSection;
